import React, { memo } from "react";
import { useTranslation } from "react-i18next";

interface MapLoadingStateProps {
  isLoaded: boolean;
}

const MapLoadingState: React.FC<MapLoadingStateProps> = memo(({ isLoaded }) => {
  const { t } = useTranslation();
  
  if (isLoaded) return null;

  return (
    <div className="map-loading">
      <div className="loading-spinner"></div>
      <p>{t("map.loadingMap")}</p>
    </div>
  );
});

MapLoadingState.displayName = "MapLoadingState";

export default MapLoadingState;
